
import fondo from '../img/fond.webp'
import image from '../img/elsa.webp'
import imageT from '../img/Captura de pantalla 2026-03-20 202513 (1).png'
import '../css/clientes.css'



const Clientes = () => {
  return (
    <section className='seccionClientes' id='clientes'>
      <img src={fondo} className='fondu' alt='fondo' />
      <div className='cardAnimation'>
        <h2 className='title'>Clientes</h2>
      </div>
      <div className='clientesContainer'>

      
      <div className='dataClientes'>
        <a className='itemClientes' href='/elsaDommarco'>
        <div className='h3box'><h3>Elsa Dommarco</h3>
        <p>sitio web</p></div>
        <img className='imgClientes' src={image} alt='elsa dommarco'/></a>
        
      </div>
       <div className='dataClientes'>
        <a className='itemClientes' href='/teatroColon'>
        <div className='h3box'><h3>Teatro Colón</h3>
        <p>app web</p></div>
        <img className='imgClientes' src={imageT} alt='teatro colón'/></a>
        
      </div>
      </div>
    </section>
  )
}

export default Clientes